webpackJsonp([1],{

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366cbb48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qhH5");
function injectStyle (ssrContext) {
  __webpack_require__("Vd4E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366cbb48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import Firebase from 'firebase';



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default.a);
// if you don't want install the component globally
// Vue.use(VueYouTubeEmbed, { global: false })

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "Vd4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qhH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container is-fluid",staticStyle:{"margin":"0 !important","background":"rgba(0, 0, 0, 0.85)","overflow":"hidden","height":"100vh"}},[_c('div',{staticClass:"columns is-gapless"},[(false)?_c('div',{staticClass:"column is-one-quarter",staticStyle:{"overflow":"overlay","height":"100vh","position":"relative"}},[_c('div',{staticClass:"field",staticStyle:{"position":"fixed","width":"inherit","z-index":"2"}},[_c('div',{staticClass:"control",staticStyle:{"text-align":"center"}},[_c('input',{staticClass:"input is-large",staticStyle:{"width":"95%","margin":"15px auto"},attrs:{"type":"text","placeholder":"Buscar"},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.searchVideo($event.target.value);}}})])]),_vm._v(" "),_c('div',{staticClass:"listResult",staticStyle:{"margin-top":"93px"}},[(_vm.searchList === 'none')?[_c('h2',{staticStyle:{"color":"rgba(255,255,255,0.85)"}},[_vm._v("No se encontraron resultados")])]:(_vm.searchList.length === 0 && _vm.searchBar === true)?[_c('progress',{staticClass:"progress is-primary is-medium",attrs:{"max":"100"},domProps:{"value":_vm.searchProgress}})]:_vm._l((_vm.searchList),function(video){return _c('div',{staticClass:"videoContainer",staticStyle:{"margin-bottom":"20px","width":"97%"}},[_c('div',{staticClass:"videoDescription",staticStyle:{"margin-bottom":"5px"}},[_c('h2',{staticClass:"videoName subtitle",staticStyle:{"color":"rgba(255,255,255,0.85)"}},[_vm._v(_vm._s(video.snippet.title))])]),_vm._v(" "),_c('img',{staticClass:"videoImage",attrs:{"src":video.snippet.thumbnails.medium.url}}),_vm._v(" "),_c('div',{staticClass:"tags has-addons tags-videos"},[_c('span',{staticClass:"tag is-pointer is-medium",on:{"click":function($event){_vm.playVideo(video)}}},[_vm._m(0,true),_vm._v(" Play Now")]),_vm._v(" "),_c('span',{staticClass:"tag is-pointer is-primary is-medium",on:{"click":function($event){_vm.addVideo(video, $event.target)}}},[_vm._m(1,true),_vm._v(" Add to list")])])])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.movie.length === 0)?[(_vm.lastVideo.length !== 0)?_c('youtube',{attrs:{"video-id":_vm.lastVideo[0].videoId,"player-vars":{ autoplay: 1 }},on:{"ready":_vm.ready,"ended":function($event){_vm.endVideo(_vm.playList[0])}}}):_vm._e()]:[_c('video',{attrs:{"id":"clip","controls":"controls","autoplay":"true"}},[_c('source',{attrs:{"src":_vm.lastVideo[0].src,"type":"video/mp4"}})])]],2)])]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showAlert)?_c('div',{staticClass:"notification position-alert is-primary"},[_c('button',{staticClass:"delete"}),_vm._v("\n      Se agregó la canción "),_c('strong',[_vm._v(" "+_vm._s(_vm.playList[_vm.playList.length - 1].title)+" ")])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-play"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-plus-circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("q6Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var config = {
  apiKey: 'AIzaSyBUDFWeu55JuHEFDI4YQrGBXFM1JL9W1MA',
  authDomain: 'taquitos-chat.firebaseapp.com',
  databaseURL: 'https://taquitos-chat.firebaseio.com/',
  storageBucket: 'taquitos-chat.appspot.com',
  messagingSenderId: '588166412136'
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
var db = firebaseApp.database();
var gapi = void 0;
// const userId = `wubba-${Math.round(Math.random() * 100000)}`;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      showAlert: false,
      searchBar: false,
      searchList: [],
      searchProgress: 0
    };
  },


  firebase: {
    listVideo: db.ref('videos/'),
    playList: db.ref('playList/'),
    lastVideo: db.ref('videos/').limitToLast(1),
    amOnline: db.ref('.info/connected'),
    movie: db.ref('movie/').limitToLast(1)
  },

  mounted: function mounted() {
    var _this = this;

    window.youtubeReady = function (g) {
      gapi = g;
    };

    this.$firebaseRefs.playList.limitToLast(1).on('child_added', function () {
      _this.showAlert = true;
      setTimeout(function () {
        _this.showAlert = false;
      }, 1500);
    });

    window.showMovie = function (movie) {
      _this.$firebaseRefs.movie.push({
        src: movie
      });
    };
  },

  methods: {
    ready: function ready(player) {
      this.player = player;
    },
    searchVideo: function searchVideo(name) {
      var _this2 = this;

      this.searchList = [];
      this.searchBar = true;
      this.searchProgress = 0;

      var request = gapi.client.youtube.search.list({
        part: 'snippet',
        type: 'video',
        q: encodeURIComponent(name).replace(/%20/g, '+'),
        videoEmbeddable: true,
        videoSyndicated: true,
        maxResults: 15
      });

      request.execute(function (response) {
        var increaseProgress = setInterval(function () {
          _this2.searchProgress += 1;
          if (_this2.searchProgress === 100) {
            clearInterval(increaseProgress);
            if (response.result.items.length === 0) {
              _this2.searchList = 'none';
            } else {
              _this2.searchList = response.result.items;
            }
          }
        }, 0.3);
      });
    },
    playVideo: function playVideo(video) {
      var title = video.snippet.title;
      var videoId = video.id.videoId;
      this.$firebaseRefs.listVideo.push({
        videoId: videoId,
        title: title
      });
    },
    addVideo: function addVideo(video, elm) {
      var title = video.snippet.title;
      var videoId = video.id.videoId;

      // eslint-disable-next-line
      elm.style.display = 'none';

      this.$firebaseRefs.playList.push({
        videoId: videoId,
        title: title
      });
    },
    endVideo: function endVideo(video) {
      if (this.playList.length > 0) {
        this.$firebaseRefs.listVideo.push({
          videoId: video.videoId,
          title: video.title
        });
        this.$firebaseRefs.playList.child(this.playList[0]['.key']).remove();
      }
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ec2a31926ec2aa210b0b.js